<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('collectionManagement')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>催收短信配置</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+添加短信配置</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="smsName" label="短信内容" ></el-table-column>
                        <el-table-column prop="time" label="发送时间" width="200"></el-table-column>
                        <el-table-column prop="platform" label="发送平台" width="200">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.platform==0" type="info" size="mini">牛信云</el-tag>
                                <el-tag v-if="scope.row.platform==1" type="info" size="mini">颂量</el-tag>
                                <el-tag v-if="scope.row.platform==2" type="info" size="mini">墨西哥本地</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1? $t('addClassify') : $t('editClassify') " :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item label="时间" prop="time">
                        <el-date-picker
                            v-model="value1"
                            type="date"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('pingt')" prop="platform">
                        <el-select size="small" v-model="form.platform" filterable :placeholder="$t('qxz')"  style="width:300px;">
                            <el-option label="牛信云" value="0"></el-option>
                            <el-option label="颂量" value="1"></el-option>
                            <el-option label="墨西哥本地" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="短信内容" prop="smsName">
                        <el-input
                            v-model="form.smsName"
                            type="textarea"
                            :rows="3"
                        />
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    smsName: null,
                    time:null,
                    platform:null
                },
                rules: {
                    smsName:[
                        { required: true, message: "内容不能为空", trigger: 'blur' }
                    ]
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                searchform: {
                    blurry: "",
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loading: false,
                showadd: false,
                list: [],
                value1:'',

            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    smsName: null,
                    time:null,
                    platform:null
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.smsName = row.smsName
                this.value1 = row.time
                this.platform = row.platform
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            deleteproduct(row) {
                _api.delete(apiurl.smsconfig, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.pageNo = 1
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if (this.value1 == null || this.value1 == '') {
                    this.$message.error("时间不能为空")
                    return
                }
                this.form.time = this.value1
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.smsconfig, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.pageNo = 1
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            smsName: null,
                            platform:null,
                            time:null
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.smsconfig, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.pageNo = 1
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            smsName: null,
                            time:null,
                            platform:null
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.smsconfig, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry
                }).then(res => {
                    this.loading = false
                    this.blurry=
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                console.log(data)
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>